export var PromoBannerType;
(function(PromoBannerType) {
    PromoBannerType["BANNER_TYPE_UNKNOWN"] = "BANNER_TYPE_UNKNOWN";
    PromoBannerType["MARKET_COUNTDOWN"] = "MARKET_COUNTDOWN";
    PromoBannerType["MARKET_LIST"] = "MARKET_LIST";
    PromoBannerType["FAIRE_VALUES"] = "FAIRE_VALUES";
    PromoBannerType["FAIRE_DIRECT_INCENTIVES"] = "FAIRE_DIRECT_INCENTIVES";
    PromoBannerType["FIRST_ORDER_INCENTIVE"] = "FIRST_ORDER_INCENTIVE";
    PromoBannerType["SPECIAL_HOLIDAY_NET90"] = "SPECIAL_HOLIDAY_NET90";
    PromoBannerType["OPENING_ORDER_INCENTIVES"] = "OPENING_ORDER_INCENTIVES";
    PromoBannerType["AMEX_INCENTIVE"] = "AMEX_INCENTIVE";
    PromoBannerType["BRAND_PREVIEW"] = "BRAND_PREVIEW";
    PromoBannerType["BRANDS_COUNTER"] = "BRANDS_COUNTER";
    PromoBannerType["WAREHOUSE_SALE"] = "WAREHOUSE_SALE";
    PromoBannerType["EMPLOYEE_GRANTED_FREE_FREIGHT"] = "EMPLOYEE_GRANTED_FREE_FREIGHT";
    PromoBannerType["POST_SIGNUP"] = "POST_SIGNUP";
    PromoBannerType["FAIRE_DIRECT_FIRST_ORDER_INCENTIVE"] = "FAIRE_DIRECT_FIRST_ORDER_INCENTIVE";
    PromoBannerType["INSIDER_INTERNATIONAL_LAUNCH_DAY"] = "INSIDER_INTERNATIONAL_LAUNCH_DAY";
    PromoBannerType["OPEN_WITH_FAIRE"] = "OPEN_WITH_FAIRE";
    PromoBannerType["POS_INTEGRATION"] = "POS_INTEGRATION";
    PromoBannerType["REFERRAL_FOLLOWUP"] = "REFERRAL_FOLLOWUP";
    PromoBannerType["MARKETPLACE_INCENTIVE"] = "MARKETPLACE_INCENTIVE";
    PromoBannerType["INSIDER_AUTO_ENROLL"] = "INSIDER_AUTO_ENROLL";
    PromoBannerType["CONDUCTOR_BANNERS"] = "CONDUCTOR_BANNERS";
    PromoBannerType["CONSUMER_MODE"] = "CONSUMER_MODE";
    PromoBannerType["PAYMENT_TERMS"] = "PAYMENT_TERMS";
    PromoBannerType["POST_FCO_INCENTIVE_DISCOUNT_JUNE_2024"] = "POST_FCO_INCENTIVE_DISCOUNT_JUNE_2024";
    PromoBannerType["DISCOVERY_TERMS"] = "DISCOVERY_TERMS";
})(PromoBannerType || (PromoBannerType = {}));
export var LOGGED_IN_PROMO_BANNERS = [
    PromoBannerType.FAIRE_DIRECT_INCENTIVES,
    PromoBannerType.MARKET_COUNTDOWN,
    PromoBannerType.CONDUCTOR_BANNERS,
    PromoBannerType.FAIRE_VALUES,
    [
        PromoBannerType.INSIDER_AUTO_ENROLL,
        PromoBannerType.POS_INTEGRATION,
        PromoBannerType.OPEN_WITH_FAIRE,
        PromoBannerType.SPECIAL_HOLIDAY_NET90,
        PromoBannerType.OPENING_ORDER_INCENTIVES,
        PromoBannerType.AMEX_INCENTIVE,
        PromoBannerType.WAREHOUSE_SALE,
        PromoBannerType.REFERRAL_FOLLOWUP
    ],
    PromoBannerType.EMPLOYEE_GRANTED_FREE_FREIGHT
];
export var LOGGED_OUT_PROMO_BANNERS = [
    PromoBannerType.MARKET_COUNTDOWN,
    [
        PromoBannerType.SPECIAL_HOLIDAY_NET90,
        PromoBannerType.BRANDS_COUNTER,
        PromoBannerType.AMEX_INCENTIVE
    ]
];
